import React from 'react';
import Tooltip, { LEFT, RIGHT, BOTTOM, TOP, INFO, ALERT, ERROR } from '../../components/tooltip/Tooltip';
import s from './HostStyles.module.scss';

const TooltipHost = () => (
    <div className={s.editor} style={{ padding: '200px', paddingLeft: '400px' }}>
        <div style={{ padding: '30px', position: 'absolute', border: '1px green solid' }}>
            I am a div with a tooltip inside of it
            <Tooltip arrowPosition={LEFT} text="My arrow is on the left" />
            <Tooltip arrowPosition={RIGHT} text="My arrow is on the right" />
            <Tooltip arrowPosition={BOTTOM} text="My arrow is on the bottom" />
            <Tooltip arrowPosition={TOP} text="My arrow is on the top" />
        </div>

        <div style={{ padding: '30px', position: 'absolute', top: '500px', border: '1px green solid' }}>
            I am a div with a tooltip inside of it
            <Tooltip arrowPosition={LEFT} text="alert on the left" type={ALERT} />
            <Tooltip arrowPosition={RIGHT} text="error on the right" type={ERROR} />
            <Tooltip arrowPosition={BOTTOM} text="INFO ON THE bottom" type={INFO} />
            <Tooltip arrowPosition={TOP} text="Alert on the top" type={ALERT} />
        </div>
    </div>
);

export default TooltipHost;
